import React from "react";
import PropTypes from "prop-types";
import AppTableContainer from "../../../../@crema/core/AppTableContainer";
import TaxManagementAction from "./TaxManagementAction";
import { Country, State } from "country-state-city";
import { Tag, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";

function TaxManagementTable({ taxManagement }) {
  const columns = [
    {
      title: "Tax Name",
      dataIndex: "taxName",
      key: "taxName",
    },

    {
      title: "Kind Of Tax",
      dataIndex: "kindOfTax",
      key: "kindOfTax",
    },

    {
      title: "Tax Percentage",
      dataIndex: "tarifPercentage",
      key: "tarifPercentage",
      render: (tarifPercentage) => {
        // Format the tax percentage to ensure it displays with the % symbol
        return `${tarifPercentage}${tarifPercentage.toString().includes('%') ? '' : '%'}`;
      },
    },

    {
      title: "Country Code",
      dataIndex: "countryCode",
      key: "countryCode",
      render: (countryCode, record) => {
        return Country.getAllCountries().find(
          (data) => data.isoCode === countryCode
        )?.name;
      },
    },

    {
      title: "States/Provinces",
      dataIndex: "stateCodes",
      key: "stateCodes",
      render: (stateCodes, record) => {
        // Check if the stateCodes array contains a wildcard "*" (applies to all states)
        if (stateCodes.includes("*")) {
          return (
            <Tooltip title="Applies to entire country">
              <Tag color="blue" icon={<GlobalOutlined />} style={{ padding: '4px 8px' }}>
                All States/Provinces
              </Tag>
            </Tooltip>
          );
        }
        
        // Regular state display logic for specific states
        const displayLimit = 5;
        const remainingCount = stateCodes.length - displayLimit;
    
        return (
          <div style={{ maxWidth: '350px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {stateCodes.slice(0, displayLimit).map(stateCode => {
              const state = State.getStatesOfCountry(record.countryCode).find(s => s.isoCode === stateCode);
              return (
                <Tag color="green" key={stateCode}>
                  {state ? state.name : stateCode}
                </Tag>
              );
            })}
            {remainingCount > 0 && (
              <Tag color="purple">
                +{remainingCount} more
              </Tag>
            )}
          </div>
        );
      }
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      className: "customer-table-actions",
      fixed: "right",
      render: (_, record) => {
        return <TaxManagementAction data={record} />;
      },
    },
  ];
  return (
    <AppTableContainer
      className="customer-table"
      hoverColor
      data={taxManagement}
      columns={columns}
      scroll={{ x: "auto" }}
    />
  );
}

export default TaxManagementTable;

TaxManagementTable.defaultProps = {
  taxManagement: [],
};

TaxManagementTable.propTypes = {
  taxManagement: PropTypes.array,
  loading: PropTypes.bool,
};
